// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productImageCarouselStyles } from "@tps/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

const imageCss = css`
    width: 100%;
    height: 100%;
    width: 42px;
    height: 42px;
    cursor: pointer;
    justify-content: center;
    border-radius: 1px;
    img {
        width: 100%;
        height: auto;
        max-height: 100%;
        max-width: 100%;
    }
    ${xScreen("lte", "md")} {
        width: 70px;
        height: 70px;
    }
`;

productImageCarouselStyles.img = {
    css: css`
        ${imageCss}
        opacity: 0.33;
    `,
};
productImageCarouselStyles.imageSelected = {
    css: css`
        ${imageCss}
        border: 1px solid ${color("common.ui9")};
    `,
};

productImageCarouselStyles.imagesContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        ${xScreen("lte", "md")} {
            gap: 26px;
        }
        ${xScreen("lte", 767)} {
            gap: 16px;
        }
    `,
};

productImageCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        && ${IconWrapper} {
            top: 0.5em;
            color: ${color("common.ui4")};
        }
        &:disabled ${IconWrapper} {
            opacity: 0.33;
        }
        ${IconWrapper} svg {
            width: 18px;
            height: 15px;
        }
        &:hover:not(:disabled) {
            ${IconWrapper} svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

productImageCarouselStyles.nextArrowButton = {
    ...productImageCarouselStyles.prevArrowButton,
};
